export const showSuccessNotification = (context, message, duration = 1500) => {
  context.$buefy.notification.open({
    message,
    type: 'is-success',
    autoClose: true,
    position: 'is-top-right',
    duration,
  })
}

export const showErrorNotification = (
  context,
  message = 'Ocurrió un error',
  duration = 1500
) => {
  context.$buefy.notification.open({
    type: 'notification-rl-is-danger',
    message,
    autoClose: true,
    position: 'is-top-right',
    hasIcon: true,
    size: 'is-small',
    iconSize: 'is-small',
    icon: 'alert-outline',
    duration,
  })
}

export const showInfoNotification = (context, message, duration = 10000) => {
  context.$buefy.notification.open({
    type: 'notification-rl-is-info',
    message,
    duration,
    closable: false,
    position: 'is-top-right',
    hasIcon: true,
    size: 'is-small',
    iconSize: 'is-small',
    icon: 'information-outline',
  })
}
